import { useEffect, useState } from "react";

/**
 * A clock that re-renders its consumer on an interval, so a countdown ("over 2 uur") keeps telling
 * the truth while the screen stays open. Thirty seconds is fine granularity for a label that never
 * shows anything finer than whole minutes, and the Vandaag screen refetches on view-enter anyway,
 * so returning from the background is already covered.
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
